<script>
import { mapGetters, mapState } from 'vuex';
import TwTitleBar from '../../../components/TwTitleBar';

export default {
  name: 'BookingInfo',
  components: {
    TwTitleBar,
  },
  filters: {
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    ...mapGetters({
      twentyBookingUrl: 'booking/getTwentyBookingUrl',
    }),
    ...mapState({
      booking: state => state.booking.booking,
      bookingLoading: state => state.booking.booking.itemLoading,
      bookingError: state => state.booking.booking.itemError,
      bookingParticipantsLoading: state => state.booking.participants.itemsLoading,
      bookingParticipantsError: state => state.booking.participants.itemsError,
      user: state => state.app.auth.user,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('title.subName'), to: '', disabled: true },
        { text: this.booking.bookingRef, to: this.twentyBookingUrl, external: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
    loading() {
      return this.bookingLoading || this.bookingParticipantsLoading;
    },
    errorOccurred() {
      return this.bookingError || this.bookingParticipantsError;
    },
  },
};
</script>
<template>
  <v-container v-if="booking && booking.id" fluid>
    <tw-title-bar
      :title="$t('menu.booking.titleWithArea')"
      :breadcrumbs="breadcrumbs"
      :booking-info="booking"
    >
    </tw-title-bar>
    <v-layout v-if="booking" class="pt-3 pl-3 pr-3" row wrap>
      <v-flex class="pt-2 pb-2" sm5 xs12>
        <v-card
          class="pa-1 mx-auto"
          outlined
        >
          <v-layout class="pa-2">
            <v-flex class="ma-0 pa-2" sm12 xs12>
              <h3>{{ $t('info.booking') }}</h3>
              <v-flex sm12 xs12>
                {{ $t('info.booking-ref') }}: {{ booking.bookingRef }}<br>
                {{ $t('info.currency') }}: {{ booking.currency }}<br>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex class="ma-2" sm5 xs12>
        <v-card
          class="pa-1 mx-auto"
          outlined
        >
          <v-layout class="pa-2">
            <v-flex class="ma-0 pa-2" sm12 xs12>
              <h3>
                {{ $t('info.customer') }}
                <v-chip
                  v-if="booking.customer.type"
                  color="red"
                  text-color="white"
                  class="caption"
                  disabled
                  small
                >
                  {{ $t('info.not-verified') }}
                </v-chip>
                <v-chip
                  v-else
                  color="green"
                  text-color="white"
                  disabled
                  small
                >
                  {{ $t('info.verified') }}
                  <v-icon right>check_circle</v-icon>
                </v-chip>
              </h3>
              <v-flex sm12 xs12>
                {{ booking.customer.firstName }} {{ booking.customer.lastName }}<br>
                {{ booking.customer.email }}<br>
                {{ booking.customer.phone }}
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex sm10 xs12>
        <v-card
          class="mx-auto"
          outlined
        >
          <v-layout class="pa-2">
            <v-flex v-for="stay in booking.stays" :key="stay.id" class="ma-0 pa-2" sm12 xs12>
              <h3>
                {{ $t('info.stay') }} "{{ booking.bookingRef + '-' + stay.stayRef }}"
                <v-chip
                  v-if="stay.cancelledDate"
                  color="red"
                  text-color="white"
                  class="caption"
                  disabled
                  small
                >
                  {{ $t('info.cancelled') }}
                </v-chip>
              </h3>
              <v-flex sm12 xs12>
                {{ $t('info.arrival') }}: {{ stay.arrivalDate | formatDate }}<br>
                {{ $t('info.departure') }}: {{ stay.departureDate | formatDate }}<br><br>
                {{ $t('info.supplier-ref') }}: {{ stay.bookingRefExternal }}<br>
                {{ $t('info.supplier-net-currency') }}: {{ stay.netCurrency }}<br>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/booking/info/BookingInfo.vue